<script>
export default {
  created() {
    const handler = (e) => {
      if (e.key === 'Escape' && this.onEsc && this.escapableVisible) {
        this.onEsc()
      }
    }

    window.addEventListener('keyup', handler)

    this.$once('hook:destroyed', () => {
      window.removeEventListener('keyup', handler)
    })
  },
}
</script>
